<template>
  <section v-if="projects.length" class="py-20">
    <div class="container mx-auto px-6">
      <div class="mx-auto max-w-7xl">
        <div v-reveal class="mb-12 text-center">
          <h2 class="mb-4 text-3xl font-bold text-ternary-dark dark:text-primary-light sm:text-4xl">
            Example <span class="bg-gradient-to-r from-accent to-gradient-end bg-clip-text text-transparent">projects</span>
          </h2>
          <p class="text-lg text-gray-600 dark:text-gray-400">
            Work that shows what this looks like in practice
          </p>
        </div>
        <ProjectsGrid :projects="projects" :filterable="false" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import ProjectsGrid from '~/components/Projects/ProjectsGrid.vue'
import { projectsForService } from '~/utils/projects'

const props = defineProps<{ slug: string }>()

const projects = projectsForService(props.slug)
</script>
